module.exports = __webpack_public_path__ + "media/images/emblems/Stansstad-coat_of_arms-60fd4d18ae39623249ab40a99b2db8bf.svg";